import { render, staticRenderFns } from "./authorized.layout.vue?vue&type=template&id=714567d6&scoped=true&"
import script from "./authorized.layout.vue?vue&type=script&lang=js&"
export * from "./authorized.layout.vue?vue&type=script&lang=js&"
import style0 from "./authorized.layout.vue?vue&type=style&index=0&id=714567d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714567d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
